export default function PostTitle({ children }) {
  return (
    <h1 className="xs:pt-2 md:pt-0 text-2xl md:text-3xl lg:text-4xl font-bold tracking-tighter leading-tight md:leading-none mb-8 text-center md:text-left">
      {children}
    </h1>
  );
}
